import Button from "../../uiComponents/Button";
import btnImg from "../../../static/images/btn_img.svg";
import { useDispatch } from "react-redux";
import { signInAtcion } from "../../../store/actions/user";
import React, { useState } from "react";
import { isElement } from "react-dom/test-utils";

const SignIn = () => {
    //const [agree, setAgree] = useState(false);
    const dispatch = useDispatch();
    const handleCLick = () => {
        const path = window.location.pathname
        if (path === '/admin') {
            dispatch(signInAtcion(true));
        } else {
            dispatch(signInAtcion(false));
        }
    };
    //const agreement = () => {
    //    setAgree((prevState) => !prevState);
    //};

    const [isDisabled, setIsDisabled] = useState(true);
    const [checked, setChecked] = useState(false);

    const canBeSubmitted = () => {
        return checked ? setIsDisabled(true) : setIsDisabled(false);
    };

    const onCheckboxClick = () => {
        setChecked(!checked);
        return canBeSubmitted();
    };


    return (
        <div className="sing-in">
            <div className="form">
                <h1>
                    Sign In
                </h1>

                <Button
                    disabled={isDisabled}
                    clickFunction={handleCLick}
                    transparent
                >
                    Sign In with
                    <img
                        src={btnImg}
                        alt="Autodesk"
                    />
                </Button>
                <h3>
                    You may also need to provision your BIM 360 Docs account for this app.
                </h3>
                <br/>
                <label className="checkbox checkbox-control">
                    I agree to the&nbsp;
                    <a
                        href="https://sites.google.com/view/bim-portal-mod/%D7%AA%D7%A0%D7%90%D7%99-%D7%A9%D7%99%D7%9E%D7%95%D7%A9"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Terms of Use
                    </a>
                    &nbsp; and the&nbsp;
                    <a
                        href="https://sites.google.com/view/bim-portal-mod/%D7%AA%D7%A0%D7%90%D7%99-%D7%A9%D7%99%D7%9E%D7%95%D7%A9"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Privacy Statement
                    </a>
                    <input
                        type="checkbox"
                        name="agree"
                        onClick={onCheckboxClick} 
                    />
                    <div className="checkbox-indicator"></div>
                </label>
            </div>
        </div>
    );
};

export default SignIn;
